import { type BuilderComponent } from 'hb-builder/types';
import { type EmailSchemaBuilder } from 'hb-builder/utils/migrate/schemas/types';
import { type DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

const needMigration = (doc: DocumentItem, date: string) =>
  doc?.attributes?.lastSave &&
  new Date(doc.attributes.lastSave).getTime() < new Date(date).getTime();

const schemas = [
  ({ document }: EmailSchemaBuilder<BuilderComponent>) => {
    if (needMigration(document, '2022-07-01')) {
      return {
        Text: {
          attributes: () => ({
            textBackgroundColor: () => null,
          }),
        },
      };
    }

    return null;
  },
  ({ document }: EmailSchemaBuilder<BuilderComponent>) => {
    if (needMigration(document, '2023-07-23')) {
      return {
        Column: {
          attributes: (attr) => ({
            verticalAlign: () => {
              if (attr.verticalAlign === true) {
                return 'top';
              }

              return attr.verticalAlign;
            },
          }),
        },
        Section: {
          attributes: (attr) => ({
            verticalAlign: () => {
              if (attr.verticalAlign === true) {
                return 'top';
              }

              return attr.verticalAlign;
            },
          }),
        },
        Hero: {
          attributes: () => ({
            fullWidth: () => false,
          }),
        },
      };
    }

    return null;
  },
  ({ document }: EmailSchemaBuilder<BuilderComponent>) => {
    // Add category to all single components
    if (needMigration(document, '2023-10-01')) {
      return {
        EmailImage: {
          category: () => 'single',
        },
      };
    }

    return null;
  },
  ({ document }: EmailSchemaBuilder<BuilderComponent>) => {
    // Replace Tahoma font with Helvetica Neue in Text components
    if (needMigration(document, '2025-05-08')) {
      return {
        Text: {
          content: (content) => {
            if (typeof content === 'string') {
              return content.replace(
                /font-family:\s*Tahoma;/g,
                'font-family: &quot;Helvetica Neue&quot;;',
              );
            }

            return content;
          },
          attributes: (attr) => ({
            textFontFamily: () => {
              if (attr.textFontFamily === 'Tahoma') {
                return 'Helvetica Neue';
              }

              return attr.textFontFamily;
            },
          }),
        },
        EmailPublication: {
          attributes: () => ({
            dynamicAttributes: () => ({
              fontFamily: (oldFontFamily) =>
                oldFontFamily === 'Tahoma' ? 'Helvetica Neue' : oldFontFamily,
            }),
          }),
        },
        Button: {
          attributes: () => ({
            buttonFontFamily: (oldFontFamily) =>
              oldFontFamily === 'Tahoma' ? 'Helvetica Neue' : oldFontFamily,
          }),
        },
        EmailList: {
          attributes: () => ({
            dynamicAttributes: () => ({
              fontFamily: (oldFontFamily) =>
                oldFontFamily === 'Tahoma' ? 'Helvetica Neue' : oldFontFamily,
            }),
          }),
        },
      };
    }

    return null;
  },

  ({ document }: EmailSchemaBuilder<BuilderComponent>) => {
    if (needMigration(document, '2025-08-31')) {
      return {
        EmailList: {
          attributes: () => ({
            dynamicAttributes: () => ({
              fields: () => ({
                displayGroup: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
                displaySectionHeadline: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
              }),
              sectionTitle: (oldValue) =>
                oldValue === undefined ? '' : oldValue,
            }),
          }),
        },
        EmailPublication: {
          attributes: () => ({
            dynamicAttributes: () => ({
              fields: () => ({
                // put previously non existing values to true
                displayCoverPicture: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
                displayDate: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
                displayGroup: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
                displayRegisterButton: (oldValue) =>
                  oldValue === undefined ? true : oldValue,
              }),
            }),
          }),
        },
        Image: {
          category: () => 'single',
          type: () => 'EmailImage',
        },
      };
    }

    return null;
  },
];

export default schemas;
